document.addEventListener("DOMContentLoaded", function () {

  /* =========================================
     MOBILE MENU
  ========================================= */

  const menuButton =
    document.querySelector("[data-menu-button]");

  const mobileMenu =
    document.querySelector("[data-mobile-menu]");


  if (menuButton && mobileMenu) {

    menuButton.addEventListener("click", function () {

      const isOpen =
        mobileMenu.classList.toggle("is-open");

      menuButton.classList.toggle(
        "is-active",
        isOpen
      );

      menuButton.setAttribute(
        "aria-expanded",
        isOpen ? "true" : "false"
      );

      menuButton.setAttribute(
        "aria-label",
        isOpen ? "Close menu" : "Open menu"
      );

    });


    /* Close after navigation */

    const mobileLinks =
      mobileMenu.querySelectorAll("a");

    mobileLinks.forEach(function (link) {

      link.addEventListener("click", function () {

        mobileMenu.classList.remove("is-open");

        menuButton.classList.remove("is-active");

        menuButton.setAttribute(
          "aria-expanded",
          "false"
        );

        menuButton.setAttribute(
          "aria-label",
          "Open menu"
        );

      });

    });


    /* Close when clicking outside */

    document.addEventListener("click", function (event) {

      if (
        !mobileMenu.contains(event.target) &&
        !menuButton.contains(event.target)
      ) {

        mobileMenu.classList.remove("is-open");

        menuButton.classList.remove("is-active");

        menuButton.setAttribute(
          "aria-expanded",
          "false"
        );

      }

    });

  }


  /* =========================================
     ESC KEY
  ========================================= */

  document.addEventListener("keydown", function (event) {

    if (event.key !== "Escape") {
      return;
    }

    if (mobileMenu) {
      mobileMenu.classList.remove("is-open");
    }

    if (menuButton) {

      menuButton.classList.remove("is-active");

      menuButton.setAttribute(
        "aria-expanded",
        "false"
      );

      menuButton.setAttribute(
        "aria-label",
        "Open menu"
      );

    }

  });


  /* =========================================
     IMAGE ERROR HANDLING
  ========================================= */

  const images =
    document.querySelectorAll("img");

  images.forEach(function (image) {

    image.addEventListener("error", function () {

      image.style.visibility = "hidden";

    });

  });

});